import { Sha256 } from '@aws-crypto/sha256-js'

const toHex = (v: number) => {
  return `0${v.toString(16)}`.slice(-2)
}

export const createSha256Hash = async (str: string) => {
  const subtleCrypto = globalThis.crypto?.subtle
  if (subtleCrypto && typeof TextEncoder === 'function') {
    const digest = await subtleCrypto.digest(
      'SHA-256',
      new TextEncoder().encode(str),
    )
    return Array.from(new Uint8Array(digest)).map(toHex).join('')
  }

  const hash = new Sha256()
  hash.update(str)
  return Array.from(new Uint8Array(hash.digestSync())).map(toHex).join('')
}
